module.exports = __webpack_public_path__ + "img/icon_content.8d4469a5.png";